import { faLocationDot } from "@fortawesome/pro-solid-svg-icons/faLocationDot";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { getDreamSearchPageHeadingParts } from "@portal/app/health/_components/utils/searchHelpers";

export const DreamSearchPageHeading = ({
  industry,
  searchCity,
  searchState,
  searchZip,
  suppressLocation = false,
  isLocationLoading = false,
  onEditLocation,
}: {
  industry?: GQL.VocationIndustry;
  searchCity?: string;
  searchState?: string;
  searchZip?: string;
  suppressLocation?: boolean;
  isLocationLoading?: boolean;
  onEditLocation: () => void;
}) => {
  const { subject, location } = getDreamSearchPageHeadingParts({
    industry,
    searchCity,
    searchState,
    searchZip,
    suppressLocation,
  });

  return (
    <Heading variant="page_title" data-testid="dream-search-header">
      {subject}
      {location && (
        <>
          {" in "}
          <LocationButton
            type="button"
            onClick={onEditLocation}
            aria-label={`Change location: ${location}`}
            aria-busy={isLocationLoading}
            data-testid="clickable-zip-code"
          >
            <FontAwesomeIcon aria-hidden="true" icon={faLocationDot} />
            {location}
          </LocationButton>
        </>
      )}
    </Heading>
  );
};

const Heading = styled(Typography)`
  margin: 0;
  text-transform: uppercase;
`;

const LocationButton = styled("button")`
  display: inline-flex;
  appearance: none;
  padding: 0;
  border: 0;
  background: none;
  color: ${({ theme }) => theme.palette.primary.main};
  font: inherit;
  text-align: left;
  text-decoration: underline;
  text-transform: inherit;
  gap: 0.25rem;
  align-items: center;
  vertical-align: bottom;

  &:hover {
    cursor: pointer;
  }
`;
